import React from "react";
import { MainPage } from "../MainPage";
import { ErrorPage } from "../ErrorPage";
import { settings } from "../../settings";
import { Layout } from "antd";
import { Route, Router, Switch } from "react-router-dom";
import { UnsubscribePage } from "../UnsubscribePage";
import { NewsEventPage } from "../NewsEventPage";
import { UseGetSubscription } from "../MainPage/hooks/UseGetSubscription";
import { UseGetNewsEventSubscription } from "../NewsEventPage/hooks/UseGetNewsEventSubscription";

// Each page loads its own subscription. They are keyed by different ids on
// different endpoints, so fetching at the router level would send the news
// event id to the email subscription API and bounce every visitor to the
// error page.
const IndexRoute = () => {
  const [styles = {}, isAppReady = false] = UseGetSubscription();
  return <MainPage styles={styles} isAppReady={isAppReady} />;
};

const NewsEventRoute = () => {
  const [styles = {}, isAppReady = false] = UseGetNewsEventSubscription();
  return <NewsEventPage styles={styles} isAppReady={isAppReady} />;
};

export const AppRouter = () => {
  return (
    <Layout>
      <Router history={settings.history}>
        <Switch>
          <Route path={["/*/news-event", "/news-event"]} component={NewsEventRoute} />
          <Route path={["/*/unsubscribe", "/unsubscribe"]} component={UnsubscribePage} />
          <Route path={["/*/error-page", "/error-page"]} component={ErrorPage} />
          <Route path={["/"]} exact component={IndexRoute} />
        </Switch>
      </Router>
    </Layout>
  );
};
